import * as AlarmVelActions from '../actions/alarm-vel.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  isLoading: false,
  loadingById: {},
  pathSuccess: null,
};

export default function alarmVel(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case AlarmVelActions.LOAD:
    case AlarmVelActions.LOAD_ONE:
      // case RequirementsActions.LOAD_CONTRACT:
      // case AlarmVelActions.CREATE:
      return {
        ...state,
        isLoading: true,
      };

    case AlarmVelActions.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.data.reduce((acc, item) => {
          acc[item.ala_id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.ala_id),
        pathSuccess: null,
      };
    case AlarmVelActions.VOID:
      return {
        ...state,
        isLoading: false,
        entities: {},
        ids: [],
        group: {},
      };
    default:
      return state;
  }
}

export const getEntities = (state) => state.alarmsVel.entities;
export const getData = (state) => state.alarmsVel.ids.map((id) => state.alarmsVel.entities[id]);
export const getDataById = (state, id) => state.alarmsVel.entities[id];
export const getIsLoading = (state) => state.alarmsVel.isLoading;
// aths
export const getPath = (state) => state.alarmsVel.pathSuccess;
